import React from 'react';
import { DriverPool } from './components/DriverPool';
import { CollapsibleScheduleSection } from './components/CollapsibleScheduleSection';
import { Controls } from './components/Controls';
import { useDriverSchedules } from './hooks/useDriverSchedules';
import { useScheduleManager } from './hooks/useScheduleManager';
import LoadMask from '../../../Utils/LoadMask';
import ManagedInOdooNotice from '../ManagedInOdooNotice';
import './styles/styles.css';

export const ScheduleManagement = () => {
   const {
      unassignedDrivers,
      allCustomDriverShifts,

      stations,
      scheduleFilters,
      setScheduleFilters,

      filteredSchedules,
      GetData,
      fetchingData,
   } = useDriverSchedules();

   const {
      exportSchedules,
      loadingManagement,
   } = useScheduleManager();

   return (
      <div className="schedule-management__container">
         <ManagedInOdooNotice what="Schedule assignments" />

         <LoadMask loading={fetchingData || loadingManagement} dark blur>
            <Controls
               onExport={exportSchedules}
               stations={stations}
               scheduleFilters={scheduleFilters}
               setScheduleFilters={setScheduleFilters}
               refetchData={GetData}
            />

            <div className="schedule-management__main-container">
               <DriverPool drivers={unassignedDrivers} />

               <div className="schedule-management__schedules-container">
                  {filteredSchedules.map((schedule) => (
                     <CollapsibleScheduleSection
                        key={schedule.id}
                        schedule={schedule}
                        allCustomDriverShifts={allCustomDriverShifts}
                     />
                  ))}
               </div>
            </div>
         </LoadMask>
      </div>
   );
};
